import { render, staticRenderFns } from "./ToggleFullscreenButton.vue?vue&type=template&id=8c9b6d0a&scoped=true&"
import script from "./ToggleFullscreenButton.vue?vue&type=script&lang=js&"
export * from "./ToggleFullscreenButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c9b6d0a",
  null
  
)

export default component.exports